import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState, PageHeader } from '@/shared/ui';

export interface SectionPlaceholderPageProps {
  /** Tytul sekcji — ten sam tekst co pozycja w pasku nawigacji. */
  title: string;
  icon?: ReactNode;
  action?: ReactNode;
}

/**
 * Zaslepka dla sekcji, ktore maja pozycje w nawigacji, ale nie maja jeszcze widoku.
 *
 * Dzieki niej klikniecie w pasku bocznym nie konczy sie strona „nie znaleziono”.
 */
export function SectionPlaceholderPage({ title, icon, action }: SectionPlaceholderPageProps) {
  const { t } = useTranslation('common');

  return (
    <>
      <PageHeader title={title} actions={action} />

      <EmptyState
        {...(icon ? { icon } : {})}
        title={t('section.emptyTitle')}
        description={t('section.emptyDescription', { section: title })}
        className="min-h-[24rem]"
      />
    </>
  );
}
